var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModuleHeader',{attrs:{"moduleName":_vm.mountedModule.name[_vm.$i18n.locale]}}),_c('div',{ref:"moduleContainer",staticClass:"content-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }